import React, { Component } from 'react'
import Albumart from '../Albumart/Albumart'
import mean from 'lodash/mean'
import chunk from 'lodash/chunk'

import Analyzer from '../Analyzer'

const LASTFM_KEY = '0c8c4a25aa16538f82d12d9f76636c3e'

const ICY_URL = 'http://92.46.51.118:8000'
const MOUNT = '/playone'
const META_INTERVAL = 9000

const AUDIO_SOURCE = `${ICY_URL}${MOUNT}`
const METADATA_SOURCE = `${ICY_URL}/json.xsl`

import playIcon from './play.svg'
import pauseIcon from './pause.svg'

import './Player.css'

export default class Player extends Component {
  state = {
    volume: 5,
    freq: 0,
    playing: false,
    imageUrl: null,
    artist: '',
    track: ''
  }

  componentDidMount () {
    this.audio = new Audio(AUDIO_SOURCE)
    this.audio.crossOrigin = 'anonymous'
    this.audio.volume = parseFloat(this.state.volume / 10)

    this.audio.addEventListener('volumechange', this.handleVolumeChangeEvent)
    this.audio.addEventListener('playing', this.handlePlayingEvent)
    this.audio.addEventListener('pause', this.handlePauseEvent)

    this.analyzer = new Analyzer(this.audio)
    this.analyzer.addListener('bands', this.readWaveform)

    this.audio.play()
  }

  componentWillUnmount () {
    clearInterval(this.metaInterval)

    this.audio.stop()
  }

  readWaveform = (bands) => {
    const normalizedFreqs = chunk(bands, Math.ceil(bands.length / 3)).map(mean)
    this.setState({ freq: normalizedFreqs })
  }

  handleMetadata = (data) => {
    if (!data) {
      return
    }

    const { title } = data
    const [ artist, track ] = title.split(' - ');

    if (artist !== this.state.artist || track !== this.state.track) {
      this.requestAlbumart(artist, track);
    }

    this.setState({ artist, track });
  }

  handleAlbumartData = (data) => {
    const { track } = data

    if (track.album) {
      this.setState({
        imageUrl: track.album.image[3]['#text']
      })
    }
  }

  requestAlbumart = (artist, track) => {
    fetch(`http://ws.audioscrobbler.com/2.0/?method=track.getInfo&api_key=${LASTFM_KEY}&artist=${encodeURIComponent(artist)}&track=${encodeURIComponent(track)}&format=json`)
      .then(response => response.json())
      .then(this.handleAlbumartData)
  }

  requestMetadata = () => {
    fetch(METADATA_SOURCE)
      .then(response => response.json())
      .then(json => this.handleMetadata(json.mounts[MOUNT]))
  }

  handlePlayingEvent = () => {
    this.requestMetadata()
    this.metaInterval = setInterval(this.requestMetadata, META_INTERVAL)

    this.setState({ playing: true })
  }

  handlePauseEvent = () => {
    clearInterval(this.metaInterval)

    this.setState({ playing: false })
  }

  handleVolumeChangeEvent = (event) => {
    this.setState({ volume: event.target.volume * 10 })
  }

  handleVolumeSliderChange = (event) => {
    this.audio.volume = parseFloat(event.target.value / 10)
  }

  handleToggleClick = () => {
    const { playing } = this.state

    if (playing) {
      this.audio.pause()
    } else {
      this.audio.play()
    }
  }

  render () {
    const { volume, playing, freq, imageUrl, artist, track } = this.state

    return (
      <div className="Player">
        <div className="Player__art">
          {imageUrl && <Albumart imageUrl={imageUrl} freq={freq} />}
        </div>
        {(artist && track) && (
          <div className="Player__meta">
            <span className="meta-info meta-info--artist">{artist}</span>
            <span className="meta-info meta-info--track">{track}</span>
          </div>
        )}
        <div className="Player__controls">
          <button
            className="Playback-control"
            onClick={this.handleToggleClick}
          >
            <img
              src={playing ? pauseIcon : playIcon}
              alt="Playback control"
            />
          </button>
          <input
            type="range"
            min="0"
            max="10"
            step="0.1"
            value={volume}
            onChange={this.handleVolumeSliderChange}
          />
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/Player/Player.js
 **/